var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLampFloor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M256.006 448H224.003V255.75H159.997V448H127.994C99.616 448 72.988 466.5 64.737 492.125C61.487 502 69.863 512 80.239 512H303.761C314.137 512 322.513 502 319.263 492.125C311.012 466.5 284.384 448 256.006 448ZM381.394 179.375L312.762 19.375C307.762 7.625 296.26 0 283.384 0H100.616C87.74 0 76.238 7.625 71.238 19.375L2.606 179.375C-1.644 189.25 -0.644 200.625 5.231 209.625C11.232 218.625 21.233 224 31.984 224H352.016C362.767 224 372.768 218.625 378.769 209.625C384.644 200.625 385.644 189.25 381.394 179.375Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLampFloor);
export default __webpack_public_path__ + "static/media/lamp-floor.c8b6e32d87e7f4ff81e11baf38df75f5.svg";
export { ForwardRef as ReactComponent };